import React, { Component } from 'react';
import './style.scss';
import { MODAL_PRESENTATION_DELETE, showModal, MODAL_PRESENTATION_FORM, MODAL_PRESENTATION_COPY, MODAL_SLIDER_FORM, MODAL_SLIDER_DELETE, MODAL_SLIDER_SHARE } from '../../../../../../modules/modals';
import {Link} from 'react-router-dom'
import history from '../../../../../../history';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux'
import { getFolderSlider } from '../../../../actions';
import {toastr} from 'react-redux-toastr'
import moment from 'moment';
import sign from 'jwt-encode'

class Item extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      played: false,
      stop: true,
      isCloseLoaded: false,
    }
  }

  render() {
    const {slider, urlApi, showModal, siteUrl} = this.props;
    const {stop, isCloseLoaded} = this.state;
    const {formatMessage} = this.context;

    const token = sign({id: slider.id}, 'qbm31')
    return (
      <div className="col-md-4 Item" 
        
      >
        <div className="item-container" style={{cursor: 'pointer'}} onClick={() => {
          if(!slider.started){
            history.push('/slider/' + slider.id)
          }
        }}>
          <div className="item-content" 
            onMouseEnter ={(e) => {
              e.stopPropagation();
              const {folder} = this.props;
              this.props.getFolderSlider(folder.id, true)
            }}
          >
            <div className="icon-delete" onClick={(e)=>{
              e.stopPropagation();
              const { showModal } = this.props;
              showModal({
                modalType : MODAL_SLIDER_DELETE,
                modalProps : {
                  id: slider.id
                }
              });
            }}>
              <i className="fas fa-times"></i>
            </div>
            <div className="icon-setting" onClick={(e) => {
              e.stopPropagation();
              history.push('/slider/' + slider.id)
            }}>
              <i className="fas fa-cog"></i>
            </div>
            <div className="icon-link" onClick={(e) => {
              e.stopPropagation();
              var copyText = document.getElementById("copy-link" + slider.id);

              /* Select the text field */
              copyText.select();
              copyText.setSelectionRange(0, 99999); /*For mobile devices*/
            
              /* Copy the text inside the text field */
              document.execCommand("copy");
              toastr.success(formatMessage('linkMessage'), formatMessage('linkMsgCopy'))
            }}>
              <input id={"copy-link" + slider.id} style={{opacity: 0, width: 1, zIndex: -1, position: 'absolute'}} value={window.location.origin + '/slider/view/' + token} />
              <i style={{zIndex: 99}} className="fas fa-link"></i>
            </div>
            <div className="icon-setting edit" onClick={(e) => {
              e.stopPropagation();
              showModal({
                modalType : MODAL_SLIDER_FORM,
                modalProps : {
                  initialValues: slider,
                  siteUrl
                }
              });
            }}>
              <i className="fas fa-pencil-alt"></i>
            </div>
            <div style={{right: 27}} className="icon-setting edit" onClick={(e) => {
              e.stopPropagation();
              showModal({
                modalType : MODAL_SLIDER_SHARE,
                modalProps : {
                  id: token
                }
              });
            }}>
              <i className="fas fa-code"></i>
            </div>
            <div className="block" style={{backgroundImage: slider.first_slider ? `url(${slider.first_slider.src})` : 'none'}}>
            
            </div>
          </div>
        </div>
        <div className="title-pres" title={slider.name}>{slider.name}</div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  folder: state.slider_folders.item,
})

const mapDispatchToProps = {
  getFolderSlider,
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Item)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Sliders/components/PresentationItems/components/Item/Item.jsx